import { render, staticRenderFns } from "./ui-period-picker.vue?vue&type=template&id=d6ef3dc4&"
import script from "./ui-period-picker.vue?vue&type=script&lang=ts&"
export * from "./ui-period-picker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports